import React from "react"

const ThirdStep = ({ classes }) => {
	return (
		<div className={classes['custom-form__feedback']}>
			<h2>
				Felicitări!
			</h2>
				<p>
					Programarea ta a fost înregistrată cu succes. 
				</p>
			<div>
				<p>În cel mult 24 de ore, consultantul tău dedicat te va contacta pentru a confirma ora și data sosirii tale.
				</p>
			</div>
		</div>
	)
}

export default ThirdStep
